export default __webpack_public_path__ + "images/0xffff003a6bad9b743d658048742935fffe2b6ed7.png";